<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Iniciar pausa</span>
  <button mat-icon-button (click)="cancelar()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col">
        <mat-form-field class="w-100">
          <textarea matInput placeholder="Motivo de la pausa" formControlName="motivo" rows="3"></textarea>
          <mat-hint>Indique el motivo de la pausa</mat-hint>
          <mat-error *ngIf="form.controls['motivo'].hasError('required')">
            <small>
              El motivo es <strong>obligatorio</strong>
            </small>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancelar()">
    <mat-icon>cancel</mat-icon>
    Cancelar
  </button>
  <button mat-stroked-button color="primary" [disabled]="!form.valid" (click)="guardar()" class="ms-2">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions> 